import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { MagneticLink } from './MagneticLink.jsx';
import { EmailCopy } from './EmailCopy.jsx';
import { SocialLinks } from './SocialLinks.jsx';

const LINKS = [
  { to: '/', label: 'Home' },
  { to: '/portfolio', label: 'Portfolio' },
  { to: '/club', label: 'Club' },
  { to: '/brand', label: 'Brand' },
  { to: '/contact', label: 'Contact' },
];

export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close the mobile menu whenever route changes. The rule flags this as a
  // cascading render, but it's semantically correct — we *want* a re-render
  // to reflect the new pathname-driven open state.
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setOpen(false);
  }, [pathname]);

  return (
    <nav className={`nav ${scrolled ? 'is-scrolled' : ''} ${open ? 'is-open' : ''}`} data-nav>
      <div className="nav-inner">
        <NavLink to="/" className="nav-brand" end>
          <span className="pulse"></span>Zongheng&nbsp;Brian&nbsp;He
        </NavLink>
        <ul className="nav-links">
          {LINKS.map((l) => (
            <li key={l.to}>
              <MagneticLink
                to={l.to}
                nav
                className={({ isActive }) => (isActive ? 'is-active' : '')}
              >
                {l.label}
              </MagneticLink>
            </li>
          ))}
        </ul>
        <div className="nav-cta">
          <SocialLinks />
          <EmailCopy label="Studio Email" />
        </div>
        <button
          type="button"
          className="nav-toggle"
          aria-label="Menu"
          onClick={() => setOpen((o) => !o)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
}
